<template>

    <div class="icon-text" @click="proxyUrl(url, isProxy)">
        <AppIcon v-if="icon" :name="icon" class="icon-text-icon"/>
        <div class="icon-text-label">
            {{title}}
        </div>
    </div>

</template>

<script>

import AppIcon from './AppIcon.vue';

export default {
    name: 'IconText',

    components: {
        AppIcon
    },

    props: {
        title: {
            type: String,
            default: 'Главная'
        },
        icon: {
            type: String,
        },
        url: {
            type: String,
            default: '/'
        },
        isProxy:{
            type: Boolean,
            default: true
        }
    },

    methods:{
        proxyUrl(url, isProxy){
            if(isProxy){
                return this.$router.push(url)
            }
        }
    }
}

</script>

<style scoped>

.icon-text{
    display: inline-flex;
    align-items: center;
    gap: 8px;

    padding: 6px 10px;
    border-radius: 8px;
    font-size: 14px;

    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    transition: background-color 0.15s ease, color 0.15s ease;
}

.icon-text:hover{
    background: var(--muted);
    cursor: pointer;
}

.icon-text-icon{
    width: 16px;
    height: 16px;
    opacity: 0.75;
}

.icon-text-label{
    white-space: nowrap;
}

</style>
